//for endpoints that return ActionResult<ObjectResult>, or something that extends ApiRequestResult/BaseApiRequestResult
//treat null as a first-class citizen for API responses
//ideally we won't need this in the future
export interface ApiResponse<T, E = number> {
  value?: T | null
  errorCode: E
  errorMessage: string | null
  success: boolean
}

export class ApiError<E = number> extends Error {
  constructor(
    message: string,
    public code: E
  ) {
    super(message)

    this.name = 'ApiError'
  }
}

export interface StripeSubscriptionPrice {
  entitlementIdentifier: string
  priceId: string
  productId: string
  price: number
  legacy: boolean
}

export interface StripeProductRecord {
  key: string
  priceIdFree: string
  priceIdPagesFree: string
  priceIdStandard: string
  priceIdPremium: string
  priceIdBasic: string
  priceIdPages: string
  priceIdSigned: string
}

export interface StripeProduct {
  key: string
  priceId: string
}

export interface StripeProducts {
  records: StripeProductRecord[]
  products: StripeProduct[]
}

export interface SentimentScanner {
  scanCacheSize: number
  maxScanLength: number
  scanRateLimitInMilliseconds: number
  learnMoreUrl: string
}

export interface WritingAssist {
  scanRateLimitInMilliseconds: number
  maxScanLength: number
}

export interface GoogleOAuth {
  clientId: string
  redirectUri: string
  scopes: string[]
  helpCenterUrl: string
}

export interface WebAppSettings {
  attachmentRestrictedFilenameChars: string
  attachmentRestrictedFileExtensions: string
  stripeSubscriptions: StripeSubscriptionPrice[]
  stripeProducts: StripeProducts
  aiSentimentScanner: SentimentScanner
  aiWritingAssist: WritingAssist
  googleOAuth: GoogleOAuth
  payForCoparentSponsorshipExpirationDays: number
}
